import styled from 'styled-components';

const StyledContent = styled.div`
  .identity__field-birthday input {
    letter-spacing: 2px;
  }
  .identity__birthday-extended-wrapper {
    position: relative;
  }
  .identity__birthday-extended {
    display: flex;
    justify-content: space-between;
  }
  .identity__field-birthday-select-wrapper {
    width: 100%;
    margin-right: 10px;
    margin-bottom: 0;
  }
  .identity__field-birthday-select {
    margin-bottom: 0;
  }
  .identity__field-birthday-select > div > div {
    margin-top: 0;
  }
  .identity__field-birthday-hint {
    position: absolute;
    bottom: 12px;
    padding: 4px 12px;
    color: #606060;

    &.with-error {
      color: #e02d21;
    }
  }
  .identity__benefits_toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }
  .identity__benefits_toggle a {
    font-size: 10px;
  }
  .identity__activate-account-link {
    font-size: 16px;
  }

  .identity__field #password__message {
    display: none;
  }
  .identity__password-hint {
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 16px;
    }
  }
  .identity__password-hints-wrapper {
    margin-top: 10px;
    width: 100%;
    padding-left: 24px;

    &.identity__password-hints-wrapper-non-empty {
      padding-left: 0;

      .identity__password-hint {
        display: flex;
        align-items: center;
      }
    }
  }
  .identity__page-heading {
    margin-top: 48px;
    margin-bottom: 24px;
    font-size: 24px;
    line-height: 32px;
  }
  .identity__page-info {
    font-weight: 400;
    color: #00012b;
  }
  .identity__field {
    margin-bottom: 24px;

    &.identity__field-password {
      margin-bottom: 14px;
    }

    &.identity__field-phoneInput {
      margin-bottom: 48px;
    }
  }

  .identity__page-guest-info {
    margin-top: 24px;
  }

  .identity__page-sub-heading,
  .identity__address-title {
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    color: #00012b;
  }

  .identity__page-sub-heading {
    margin-bottom: 24px;
  }

  .identity__field-birthday {
    margin-bottom: 60px;

    #birthDay-hint {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #00012b;
      padding: 4px 0 0;
      display: inline-block;
    }
  }

  .identity__form-submit {
    margin-top: 16px;
  }

  .identity__welcome-page {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &-info {
      margin: 16px 0 0;
      font-size: 18px;
      line-height: 1.56;
      color: #00012b;
      max-width: 140px;
      text-align: center;
    }
  }

  .identity__verification-description {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #00012b;
    margin-bottom: 32px;
  }

  .identity__form-submit.identity__signup-verify-form-submit {
    margin-top: 24px;
  }
`;

export default StyledContent;
